import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";

// Essential CSS only
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";

// Tabler Icons (for ti ti- classes)
import "../src/style/icon/tabler-icons/tabler-icons.min.css";

// Keep only FontAwesome icons (most comprehensive)
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";

// Redux store
import store from "./core/data/redux/store";
import { Provider } from "react-redux";

// Auth Context
import { AuthProvider } from "./hooks/authContext";

// Routes
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <BrowserRouter basename={base_path}>
          <ALLRoutes />
        </BrowserRouter>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);
